export default __webpack_public_path__ + "static/media/javascript.b8eabfa0.png";